/**
 * Created by Arokoyu Olalekan Ojo
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {bankDetailsProp, categoryProps, configurationProp, dashboardOverviewProps, IResponse, locales, loginPayload, transactionFilters, transactionProp, userProfile} from '../../../interfaces/iresponse';
import {ApiService} from '../../api/api.service.';
import {DecryptService} from '../../decryptService/decrypt.service';
import { filter } from 'rxjs-compat/operator/filter';
import { HttpParams } from '@angular/common/http';

interface categoryPayload {
  category_id: number,
  action: string
}
@Injectable()
export class UserService {

  constructor(private api: ApiService,
              private decryptionService: DecryptService) {

  }


  auth(data: loginPayload): Observable<IResponse> {
    return this.api.postRequest('auth', 'login' , data).map((response:IResponse) =>{ 
      return response
    });
  }

  createAgent(data: any): Observable<IResponse> {
    return this.api.postRequest('agents', null , data).map((res: IResponse)  => {
      return res ;
    });
  }

  viewAgent(id: number):Observable<any>{
    return this.api.getRequest(`agents/${id}`, 'transactions').map(response => response);
  }


  public getDashboard(): Observable<IResponse> {
    return this.api.getRequest('dashboard', null).map( (res: IResponse) => {
      return res;
    });
  }
  public logOut(): Observable<IResponse> {
    return this.api.postRequest('auth', 'logout', {}).map((res: IResponse)  => {
      return res ;
    });
  }

  public resetPassword(data): Observable<IResponse> {
    return this.api.postRequest('auth/forgot-password', 'reset', data).map( (res: IResponse) => {
      return res;
    });
  }
  public forgotPassword(data): Observable<IResponse> {
    return this.api.postRequest('auth', 'forgot-password', data).map( (res: IResponse) => {
      return res;
    });
  }
  public updatePassword(data): Observable<IResponse> {
    return this.api.postRequest('auth', 'change-password', data).map( (res: IResponse) => {
      return res;
    });
  }
  public getAllUsers(): Observable<IResponse> {
    return this.api.getRequest('user', 'null').map( (res: IResponse) => {
      return res;
    });
  }
  public updateUser(data): Observable<IResponse> {
    return this.api.putRequest('user', data.id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public getAllState(): Observable<IResponse> {
    return this.api.getRequest('states', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getAllZones(status: string, categoryId?: string | number): Observable<IResponse> {
    let params = new HttpParams();

    // filter this table with 'zones?all=1' or active or deleted
    let method;
    if(status === '1'){
      method = `zones?all=${status}`
    }else if(status === 'active' || status === 'inactive'){
      method = `zones?status=${status}`
    }else if(!status){
      method = 'zones'
    }
    
    if (categoryId){
      params = params.set('category', categoryId.toString());
    }

  return this.api.getRequest(method, null, params).map((res: IResponse) => {

    const zones = res.data.map((zone: any) => {
      let verifiedDate = null;

      if (zone.settlement_verified_at) {
        verifiedDate = new Date(zone.settlement_verified_at).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
        });
      }

      return {
        ...zone,
        settlement_verified_at: verifiedDate
      };
    });

    return {
      ...res,
      data: zones
    };
  });
}
  public fundWalletInit(data): Observable<IResponse> {
    return this.api.postRequest('transactions/generate', 'payload', data).map( (res: IResponse) => {
      return res;
    });
  }
  public fundTransferInit(data): Observable<IResponse> {
    return this.api.postRequest('wallets', 'transfer', data).map( (res: IResponse) => {
      return res;
    });
  }
  public verifyTransaction(data): Observable<IResponse> {
    return this.api.postRequest('transactions/verify', 'payment', data).map( (res: IResponse) => {
      return res;
    });
  }
  public getPaymentChannels(): Observable<IResponse> {
    return this.api.getRequest('payment_channels', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getWalletTransactions(): Observable<IResponse> {
    return this.api.getRequest('wallet_transactions', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getTransactionById(id): Observable<IResponse> {
    return this.api.getRequest('transactions', id).map( (res: IResponse) => {
      return res;
    });
  }

  public getSharingFormulas(): Observable<IResponse> {
    return this.api.getRequest('sharing_formulars`', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getMyAgents(): Observable<IResponse> {
    return this.api.getRequest('agents', null).map( (res: IResponse) => {
      return res;
    });
  }

  public getCategories(param: string):Observable<categoryProps[]>{
    const status = param.trim();
    return this.api.getRequest(
       status
        ? 
       `categories?status=${status}`
        : 
       'categories?all=1', null).map(response=>{
      
      let categories : Array<categoryProps> = [];
      for (let c of response.data.data){
        categories.push(
          {id: c.id, name: c.name, 
          slug: c.slug, status: c.status,
          daily_fee: c.daily_fee, 
          enrollment_fee: c.enrollment_fee});
      }
      return categories;
    })
  }

  public getBanks():Observable<bankDetailsProp[]>{
    return this.api.getRequest('banks', null).map(response=>response.data as bankDetailsProp[]);
  }

  public postCategory(payload:{}):Observable<categoryProps>{
    return this.api.postRequest('categories', null, payload).map(response =>{
      const {id, name, slug, status} = response.data;
      const category = {id, name, slug, status } as categoryProps;
      return category;
    })
  }

  public deleteCategory(id: number):Observable<string>{
    return this.api.deleteRequest('categories', `${id}`).map(response =>{
      const {message} = response.data;
      return message;
    })
  }

  public getAgentCollection(){
    return this.api.getRequest('reports', 'collections').map((response)=> response.data.groups);
  }

  public getAgentReport(){
    return this.api.getRequest('reports', 'agents').map(response => response.data.agents);
  }

  public toggleCategory(payload: categoryPayload):Observable<categoryProps>{
    return this.api.postRequest('categories','toggle-status', payload ).map(response =>{
      const {id, status, name, slug, enrollment_fee, daily_fee} = response.data
      const responseData = {id, status, name, slug, enrollment_fee, daily_fee};
      return responseData;
    })
  }

  public getConfigurationSettings():Observable<configurationProp>{
    return this.api.getRequest('admin', 'settings').map(response=>{
      return response.data as configurationProp;
    })
  }

  public postConfiguration(payload: configurationProp):Observable<any>{
    return this.api.putRequest('admin', 'settings',payload).map(response=>{
      return response;
    })
  }

  public getlocaleZones():Observable<Array<locales>>{
    return this.api.getRequest('zone-lgas', null).map(
      (response) => {
        const localGovts: Array<locales> = [];
        const {data} = response;
        for(let lg of data){
          if(lg.zone.status.toLowerCase() === 'active'){
            localGovts.push({lga_id: lg.lga_id, name: lg.zone.name});
          }
        }
        return localGovts;
      }
    )
  }

  public getTeamOverview():Observable<dashboardOverviewProps>{
    return this.api.getRequest('super-agent/ops', 'team').map(response => {
      return response.data as dashboardOverviewProps;
    })
  }

  public getAgentForSuperAgent(super_agent_id): Observable<IResponse> {
    return this.api.getRequest('super-agent', 'agents/' + super_agent_id ).map( (res: IResponse) => {
      return res;
    });
  }

  public filterMyAgent(filter, superAgentId): Observable<IResponse> {
    if(!filter || filter.approved === null) {
      return this.api.getRequest('super-agent', 'agents/' + superAgentId).map( (res: IResponse) => {
        return res;
      });
    } else {
      return this.api.getRequest('super-agent', `agents/${superAgentId}?status=${ (filter.approved === 1) ? 'approved' : 'not_approved'}`).map( (res: IResponse) => {
        return res;
      });
    }
  }

  public toggleAgentStatus(actionType, agentId): Observable<IResponse> {
    return this.api.postRequest('super-agent', 'toggle-agent-status/' + agentId, actionType).map( (res: IResponse) => {
      return res;
    });
  }

  public getRiders(payload: {}): Observable<any>{
    return this.api.postRequest('riders', null, payload).map(
      (response)=> {
        return response;
      }
    )
  }

  public getUserProfile():Observable<userProfile>{
    return this.api.getRequest('profile/agent', null).map(
      (response) => {
        const {van_account_number, van_bank, van_reference, van_type, van_status, van_provisioned_at } = response.data.remittance;
        const getVirtualAccountDetails = (VAD: string): string=>{
          if(VAD === null || typeof VAD === 'undefined') return '--';
          return VAD;
        }
        return {...response.data, 
          van_account_number: getVirtualAccountDetails(van_account_number),
          van_bank: getVirtualAccountDetails(van_bank),
          van_reference: getVirtualAccountDetails(van_reference),
          van_type: getVirtualAccountDetails(van_type),
          van_status: getVirtualAccountDetails(van_status),
          van_provisioned_at: getVirtualAccountDetails(van_provisioned_at)
         }
      }
    )
  }

  public getRiderP(agentId): Observable<IResponse> {
    return this.api.getRequest('agent/riders', agentId).map( (res: IResponse) => {
      return res;
    });
  }
  public getTransactions(filterBy: transactionFilters, page: number, perPage: number):Observable<transactionProp[]> {
    const httpParam = new HttpParams().set('page', page).set('perPage', perPage)
    let param = [];
    Object.entries(filterBy).forEach(([key, value])=>{
      if(filterBy[key] === '' || filterBy[key]?.length === 0 || filterBy[key] === 0 || filterBy[key] === null ){
        return
      }else{
        param.push(`${[key]}=${encodeURIComponent(filterBy[key])}`);
      }
    })
    const queryParams = `?${param.join('&')}`
    return this.api.getRequest('reports', `revenue${queryParams}`, httpParam).map( (res) => {
      const {data} = res.data;
      let issuedDate;
      const transactions = data.map((d: transactionProp)=>{
        issuedDate = new Date(d.date_time).toLocaleDateString('en-US', {
          month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric'
        })
        return {...d, date_time: issuedDate}
      })
      return transactions as transactionProp[] 
    });
  }

  public validateTicketToken(tokenId: string){
    return this.api.getRequest('tickets/validate', tokenId).map(response=> response.data);
  }

  public getWallet(userId): Observable<IResponse> {
    return this.api.getRequest('wallets/'+ userId, 'balance').map( (res: IResponse) => {
      return res;
    });
  }
}
